// src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

// --- AJUSTE: Centralizar a URL do Cockpit ---
const COCKPIT_LOGIN_URL = process.env.REACT_APP_COCKPIT_URL || '/';

// Cria o contexto
const AuthContext = createContext(null);

// Cria o Provedor do contexto
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Obtenha o token da URL, se existir
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('token');
        
        let token = localStorage.getItem('app_token');

        // =========================================================================
        // Passo 1: Prioriza o token da URL e o salva no localStorage
        // =========================================================================
        if (urlToken) {
            console.log('Token encontrado na URL. Salvando no localStorage e validando.');
            // Salva o token da URL no localStorage
            localStorage.setItem('app_token', urlToken);
            token = urlToken; // Atualiza a variável local
            
            // Limpa a URL para maior segurança
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // =========================================================================
        // Passo 2: Valida o token existente (seja da URL ou do localStorage)
        // =========================================================================
        try {
            if (token) {
                const decodedUser = jwtDecode(token);
                
                // Verifica se o token está expirado
                if (decodedUser.exp * 1000 > Date.now()) {
                    console.log('Token decodificado com SUCESSO. Acesso liberado.');
                    setUser(decodedUser);
                } else {
                    console.warn('Token expirado. Limpando e redirecionando.');
                    localStorage.removeItem('app_token');
                    window.location.href = `${COCKPIT_LOGIN_URL}?redirect_url=${window.location.href}&reason=expired_token`;
                    return; // Sai da execução para não seguir adiante
                }
            } else {
                // Se não há token (nem na URL, nem no localStorage), redireciona.
                const publicPaths = ['/auth/callback', '/access-denied'];
                if (!publicPaths.includes(window.location.pathname)) {
                    console.warn('Nenhum token encontrado. Redirecionando para login.');
                    window.location.href = `${COCKPIT_LOGIN_URL}?redirect_url=${window.location.href}`;
                    return; // Sai da execução
                }
            }
        } catch (error) {
            console.error('ERRO CRÍTICO: O token recebido não é um JWT válido!', error);
            localStorage.removeItem('app_token');
            // Opcional: Redirecionar para uma página de erro ou para o login.
            // window.location.href = `/access-denied?reason=invalid_token`;
        } finally {
            // Apenas define loading como false no final, se a página não for redirecionada.
            setLoading(false);
        }
    }, []); // Array de dependências vazio, para rodar apenas uma vez na montagem

    // --- ADIÇÃO: Função de Login (se precisar de uma forma manual de logar) ---
    const login = (token) => {
        localStorage.setItem('app_token', token);
        const decodedUser = jwtDecode(token);
        setUser(decodedUser);
        setLoading(false);
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('app_token');
        // Redireciona para o cockpit após o logout
        window.location.href = COCKPIT_LOGIN_URL;
    };
    
    // --- ALTERAÇÃO: Adiciona a função 'login' ao valor do contexto ---
    const authValue = { user, loading, login, logout };

    return (
        <AuthContext.Provider value={authValue}>
            {children}
        </AuthContext.Provider>
    );
};

// Cria um hook customizado para usar o contexto facilmente
export const useAuth = () => {
    return useContext(AuthContext);
};